export enum ApiKeys {
  DashboardExperience = 'activate/dashboard/v1',
  DashboardExperienceV2 = 'activate/customerengagement/dashboard/v2',
  OrderDeliveryDetails = 'activate/customerengagement/dashboard/order_delivery_details/v1',
}

export type DashboardExperienceApiVersion = 'v1' | 'v2'
export type DashboardExperienceCacheKey = readonly [ApiKeys, DashboardExperienceApiVersion]

export const getDashboardExperienceApiKey = (apiVersion: DashboardExperienceApiVersion) =>
  apiVersion === 'v2' ? ApiKeys.DashboardExperienceV2 : ApiKeys.DashboardExperience

export const getDashboardExperienceCacheKey = (
  apiVersion: DashboardExperienceApiVersion,
): DashboardExperienceCacheKey => [getDashboardExperienceApiKey(apiVersion), apiVersion]
